<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="用户账号">
                <el-input placeholder="请填写用户账号" v-model="queryForm.userName"></el-input>
            </el-form-item>

            <el-form-item label="联系人">
                <el-input placeholder="请填写联系人" v-model="queryForm.consignee"></el-input>
            </el-form-item>
            <el-form-item label="联系电话">
                <el-input placeholder="请输入联系电话" v-model="queryForm.contactNumber"></el-input>
            </el-form-item>
            <el-form-item label="详细地址">
                <el-input placeholder="请填写详细地址" v-model="queryForm.detailsAddress"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getMppUserAddressList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteMppUserAddress(null)"
                    >删除</el-button>
                </div>
                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshMppUserAddressList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- :header-row-style="{ height: '10px' }"
                :header-cell-style="{ padding: '10px' }"
                :row-style="{ height: '9px' }"
                :cell-style="{ padding: '9px' }" -->
            <!-- 列表数据 -->
            <el-table :data="mppUserAddressList" row-key="id" border @selection-change="handleSelectionChange" size="small" height='100%'>
                <el-table-column align="center" type="selection" width="60px"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="mppUser.userName" label="用户账号" width="150px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="consignee" label="联系人" width="150px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="contactNumber" label="联系电话" width="150px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="country.areaName" label="国家" width="100px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="province.areaName" label="省份" width="100px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="city.areaName" label="城市" width="100px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="area.areaName" label="区域" width="100px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="isDefault" label="是否默认" width="100px">
                    <template slot-scope="scop">
                        {{ scop.row.isDefault == 0 ? '否' : '是' }}
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="detailsAddress" label="详细信息" width="400px">
                </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="deleteMppUserAddress(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppUserAddressList();
                this.getMppUserAddressList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppUserAddressList();
                this.getMppUserAddressList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                detailsAddress: '', //详细信息
                userName: '', //用户账号
                consignee: '', //联系人
                contactNumber: '' //联系电话
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppUserAddressState: 'add',
            mppUserAddressStates: {
                add: '新建mpp_user_address',
                check: '查看mpp_user_address',
                edit: '修改mpp_user_address'
            },

            multipleSelection: [],
            mppUserAddressList: [],
            mppUserAddress: {
                id: '', //
                countryId: '', //国家编号
                provinceId: '', //省份编号
                cityId: '', //城市编号
                areaId: '', //区域id
                detailsAddress: '' //详细信息
            },
            btnLoading: false,

            rules: {
                id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                countryId: [{ required: true, message: '国家编号不能为空', trigger: 'blur' }],
                provinceId: [{ required: true, message: '省份编号不能为空', trigger: 'blur' }],
                cityId: [{ required: true, message: '城市编号不能为空', trigger: 'blur' }],
                areaId: [{ required: true, message: '区域id不能为空', trigger: 'blur' }],
                detailsAddress: [{ required: true, message: '详细信息不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getMppUserAddressList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMppUserAddressList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppUserAddressList = [];
        },
        resetDialog() {
            this.mppUserAddressState = 'add';
            this.showDialog = false;
            this.queryForm = {
                detailsAddress: '', //详细信息
                userName: ''
            };
            this.getMppUserAddressList();
        },
        closeDialog() {
            this.mppUserAddress = {
                id: '', //
                countryId: '', //国家编号
                provinceId: '', //省份编号
                cityId: '', //城市编号
                areaId: '', //区域id
                detailsAddress: '' //详细信息
            };
        },
        submitForm() {
            if (this.mppUserAddressState == 'add') {
                this.$refs.mppUserAddressForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/address/add`, { ...this.mppUserAddress }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppUserAddressList();
                                this.resetDialog();
                                this.getMppUserAddressList();
                            }
                        });
                    }
                });
            } else if (this.mppUserAddressState == 'edit') {
                this.$refs.mppUserAddressForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/address/edit`, { ...this.mppUserAddress }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppUserAddressList();
                                this.resetDialog();
                                this.getMppUserAddressList();
                            }
                        });
                    }
                });
            }
        },
        addMppUserAddress() {
            this.showDialog = true;
            this.mppUserAddressState = 'add';
        },
        checkMppUserAddress(mppUserAddressId) {
            console.log(mppUserAddressId);
            this.currentMppUserAddressId = mppUserAddressId;

            this.getMppUserAddressById();
            this.showDialog = true;
            this.mppUserAddressState = 'check';
        },
        editMppUserAddress(mppUserAddressId) {
            console.log('mppUserAddress', mppUserAddressId);
            if (mppUserAddressId) {
                this.currentMppUserAddressId = mppUserAddressId;
                this.getMppUserAddressById();
            } else {
                this.mppUserAddress = { ...this.mppUserAddress, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppUserAddressState = 'edit';
        },
        deleteMppUserAddress(mppUserAddressId) {
            let ids = '';
            if (mppUserAddressId) {
                ids = mppUserAddressId;
            } else {
                ids = this.multipleSelection.map((mppUserAddress) => mppUserAddress.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/address/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppUserAddressList();
                            this.getMppUserAddressList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshMppUserAddressList() {
            this.resetMppUserAddressList();
            this.getMppUserAddressList();
        },
        getMppUserAddressList() {
            this.loading = true;
            get(`/mpp/address/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success && res.code == 200) {
                    this.mppUserAddressList = res.page.list;
                    this.totalNum = res.page.total;
                }
                this.loading = true;
            });
        },
        getMppUserAddressById() {
            get(`/mpp/address/get`, { id: this.currentMppUserAddressId }).then((res) => {
                if (res.success) {
                    this.mppUserAddress = { ...this.mppUserAddress, ...res.mppUserAddress };
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppUserAddressList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/address/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/address/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/address/importData`, formData);
            this.refreshMppUserAddressList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppUserAddressList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppUserAddressList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
